module.exports = "/static/assets/e8db9671e95c4c4530eea1528936b9e7.jpg";